<template>
    <v-card>
        <ClTableSimple
            :headers="table.headers"
            :items="tableItems"
        />
    </v-card>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

export default {
    name: 'TableDeliveryItemsByDestination',
    data() {
        return {
            table: {
                headers: [
                    {
                        text: 'Drop-off Location',
                        value: 'name',
                    },
                    {
                        text: 'Items',
                        value: 'itemCount',
                        align: 'end',
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters( {
            deliverableItemsGroupedByDropOffLocation: 'Mail/Delivery/Current/deliverableItemsGroupedByDropOffLocation',
        } ),
        tableItems() {
            return this.deliverableItemsGroupedByDropOffLocation.map( ( item ) => ( {
                ...item,
                itemCount: item.items.length,
                name: item.name || 'Problem Items',
            } ) );
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep.v-data-table {
    .v-data-table__wrapper {
        table {
            tbody {
                tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
                    background: transparent;
                }
            }
        }
    }
}
</style>
